<script setup lang="ts">
import type { MLoadRef } from '~/components/m/MLoad.vue'

definePageMeta({
  layout: 'account-center'
})

const id = Number(useRoute().params.id?.toString())

const empty = ref(false)
const loaded = ref(false)
const list = ref<Post.Info[]>([])
const loadRef = ref<MLoadRef>()

onMounted(async () => {
  await load()
})

async function load() {
  const res = await fetchUserArticleList(id)
  empty.value = res.length === 0
  list.value = res
  loaded.value = true
  loadRef.value?.check()
}

async function loadMore(ev: { complete: () => void }) {
  if (empty.value || !loaded.value) {
    ev.complete()
    return
  }
  const lastId = list.value[list.value.length - 1]?.id || 0
  const more = await fetchUserArticleList(id, lastId)
  empty.value = more.length === 0
  list.value.push(...more)
  ev.complete()
}
</script>

<template>
  <MContainer title="文章" padding class="m-member">
    <MTiledPostCard v-for="p in list" :key="p.id" :post="p" />
    <MLoad ref="loadRef" :empty="empty" @on-scroll-end="loadMore" />
  </MContainer>
</template>
